import { CloudDownloadOutlined, UserAddOutlined } from "@ant-design/icons";
import { Button, Col, Input, Row } from "antd";
import React from "react";
import { ExportUser } from "../function/export_user";

const { Search } = Input;
const UserControl = (props) => {
  // -------------------------- VAR --------------------------
  const { setAdd, data, onSearch } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  const handleClick = () => {
    setAdd(true);
  };
  const handleExport = () => {
    ExportUser(data);
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  const renderAddUser = () => {
    return (
      <Col>
        <Button type="primary" onClick={handleClick}>
          <UserAddOutlined />
          Add user
        </Button>
      </Col>
    );
  };

  const renderExportUser = () => {
    return (
      <Col>
        <Button type="primary" onClick={handleExport}>
          <CloudDownloadOutlined />
          Export
        </Button>
      </Col>
    );
  };

  const renderSearchUser = () => {
    return (
      <Col>
        <Search
          placeholder="input search text"
          // onSearch={onSearch}
          allowClear={true}
          onChange={onSearch}
          style={{
            width: 300,
          }}
        />
      </Col>
    );
  };
  // -------------------------- MAIN --------------------------
  return (
    <Col span={24}>
      <Row gutter={[10, 10]} align="middle" justify="space-between">
        {renderSearchUser()}
        {renderExportUser()}
        {/* {renderAddUser()} */}
      </Row>
    </Col>
  );
};
export default UserControl;
